module.exports = "<div *ngIf=\"entityIdDetails != null && entityIdDetails.isClient\">\n    <entity-transaction-profile-client [entityIdDetails]=\"entityIdDetails\"></entity-transaction-profile-client>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/entities/transaction-profile/entity-transaction-profile.component.html
// module id = 2282
// module chunks = 0